class PropertyListController {

  constructor( $scope, $state, propertiesService, messageService, access, permissionsService, configService ) {
    this.$scope = $scope;
    this.$state = $state;
    this.propertiesService = propertiesService;
    this.messageService = messageService;
    this.access = access;
    this.user = permissionsService.user;
    this.configService = configService;
  }

  $onInit() {
    this.updatePaging();
    this.$scope.$watch(
      function (scope) {
        return scope.current_page;
      },
      function (newVal, oldVal, scope) {
        if (newVal !== oldVal){
          if (scope.$ctrl.filtertext && scope.$ctrl.filtertype && scope.$ctrl.isFiltered){
            scope.$ctrl.properties = undefined;
            scope.$ctrl.propertiesService.search(scope.$ctrl.filtertype, scope.$ctrl.filtertext, newVal).then(response => {
              scope.$ctrl.properties = response;
              scope.$ctrl.loading = false;
            });
          }
          else{
            scope.$ctrl.propertiesService.findAll(newVal, scope.per_page)
              .then(list => scope.$ctrl.properties = list);
          }
        }
      }
    );
  }

  updatePaging(){
    this.$scope.per_page = this.properties.per_page;
    this.$scope.current_page = this.properties.current_page;
    this.$scope.total = this.properties.total;
  }

  onDelete(property) {
    if (this.access.check('admin')){
      this.propertiesService.delete(property.id)
        .then(list => {
          this.messageService.success(`The property <strong>${property.name}</strong> was successfully deleted.`);
          this.messageService.push();
        })
        .catch((error) => {
          this.messageService.failure(`The property <strong>${property.name}</strong> could not be successfully deleted: ${error.statusText}`);
          this.messageService.push();
        })
        .then(() => {
          let page = this.properties.current_page;
          this.properties = [];
          this.loading = true;
          return this.propertiesService.findAll(page).then(response => {
              this.properties = response;
              this.loading = false;
          });
        });
    }
  }

  filter(){
    if (!this.loading && this.filtertext){
      this.startFilter();
      this.propertiesService.search(this.filtertype, this.filtertext).then(response => {
        this.isFiltered = true;
        this.endFilter(response);
      });
    }
  }

  clearfilter(){
    if (this.isFiltered) {
      this.startFilter();
      this.propertiesService.findAll(1, 20).then(response => {
        this.isFiltered = false;
        this.endFilter(response);
      });
    }
  }
  
  filtertypeChange() {
    switch(this.filtertype) {
      default:
        this.filtertext = '';
        break;
    }
  }

  startFilter(){
    this.loading = true;
    this.properties = undefined;
  }

  endFilter(response){
    this.properties = response;
    this.updatePaging();
    this.loading = false;
  }

  fireImport(){
    if (this.importFile && this.importFile.type === 'text/csv'){
      this.properties = undefined;
      this.propertiesService.import(this.importFile)
        .then(() => {
          this.messageService.success(`The import was received successfully`);
          this.messageService.push();

          this.propertiesService.findAll(this.$scope.current_page, this.$scope.per_page)
              .then(list => this.properties = list);
        }).catch(() => {
          this.messageService.failure(`The import was not received successfully`);
          this.messageService.push();
        });
    }
  }
}

PropertyListController.$inject = [ '$scope', '$state', 'propertiesService', 'messageService', 'access', 'permissionsService', 'configService' ];

export default PropertyListController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/controllers/property.list.controller.js